/* eslint-disable indent */
import React from "react";
import SelectInput from "../../../../component/input/SelectInput";
import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../../../constant/helper/helper";

const projectDetails = ({
  values,
  allLocations,
  currentUser,
  handleInitialState
}) => {
  return (
    <div className="row mt-1 mb-1 ">
      <div className="col-xl-3 col-lg-3 col-md-5 col-sm-5 ">
        <SelectInput
          required={true}
          name="locationId"
          textWhite={false}
          isLabeled={false}
          value={values.locationId}
          label="Select Location"
          onChange={handleInitialState}
        >
          <option value=""> Select Location</option>
          {isSuperAdmin(currentUser)
            ? renderLocationFunction(allLocations)
            : renderAccessLocation2(
                locationRender(currentUser, false)
              )}
        </SelectInput>
      </div>
    </div>
  );
};

export default projectDetails;
